import React, {Component} from 'react'
import { Analytics } from 'common-frontend'
import { Button } from 'components'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import TextField from 'material-ui/TextField'
import FontIcon from 'material-ui/FontIcon'
import { APP_NAME } from 'consts'

import Experiment  from 'react-ab-test/lib/Experiment'
import Variant  from 'react-ab-test/lib/Variant'
import emitter  from 'react-ab-test/lib/emitter'

import './SetupSurveyContainer.scss'

const answers = [
  { label: "I don't know anything about SEO.", value: 'do_not_know' },
  { label: "I have heard about SEO ideas but I don't understand them.", value: 'heard_about_it' },
  { label: "I understand SEO but I don't know what's most important.", value: 'do_not_know_whats_important' },
  { label: "I understand SEO but I don't know how to implement some techniques.", value: 'do_not_know_how_to_implement' },
  { label: 'Other', value: 'other' }
]

const ONBOARDING_SURVEY_EXPERIMENT_NAME = 'Onboarding Survey'

emitter.addPlayListener(ONBOARDING_SURVEY_EXPERIMENT_NAME, function(experimentName, variantName) {
  Analytics.track('Experiment Viewed', {
    experiment_name: experimentName,
    variation_name: variantName
  })
})

export default class SetupSurveyContainer extends Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = { selected: null, otherLevelKnowledge: '' }
  }

  componentDidMount() {
    this.context.router.push('/charge/success')
  }

  continue() {
    const { selected, otherLevelKnowledge } = this.state

    if (selected) {
      let analyticsBody = {
        email: this.context.currentUser.email,
        survey_type: 'plus_seo_knowledge',
        survey_response: selected
      }
      if (selected === 'other' && otherLevelKnowledge) analyticsBody['survey_response_detail'] = otherLevelKnowledge

      Analytics.track('Survey Answered', analyticsBody)
    }

    this.context.router.push('/charge/success')
  }

  renderSurvey() {
    return (
      <div>
        <div className="setup-logo-container">
          <img className="setup-brand-symbol" alt="Plug in Useful" src="../../assets/images/brand-symbol.png" />
          <img className="setup-logo" alt={APP_NAME} src="../../assets/images/logo-color.png" />
        </div>
        <div className="onboarding-settings">
          <div>
            <div className="onboarding-settings__header-container">
              <h2 className="onboarding-settings__title">How well do you currently understand SEO?</h2>
            </div>

            <div className="onboarding-settings__settings-container onboarding-settings__survey-container">
              <RadioButtonGroup name="answer" onChange={(_, value) => this.setState({selected: value})}>
                {answers.map((answer, index) => (
                  <RadioButton
                    value={answer.value}
                    label={<h4>{answer.label}</h4>}
                    key={`option-${answer.value}`}
                    className="onboarding-settings__survey-option"
                  />
                ))}
              </RadioButtonGroup>
              {this.state.selected === 'other' && (
                <TextField
                  name="other_level"
                  placeholder="How well do you currently understand SEO?"
                  multiLine
                  fullWidth
                  rowsMax={4}
                  value={this.state.otherLevelKnowledge}
                  onChange={({ target: { value } }) => this.setState({ otherLevelKnowledge: value })}
                />
              )}
            </div>

            <div className="onboarding-settings__footer-container">
              <Button
                label="Continue to Setup"
                buttonType="primary"
                onTouchTap={::this.continue}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <Experiment name={ONBOARDING_SURVEY_EXPERIMENT_NAME}>
        <Variant name="A">{ this.renderSurvey() }</Variant>
        <Variant name="B"></Variant>
      </Experiment>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/SetupSurveyContainer.js